import {Divider, Group, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {adjustToTimeZone, Entity, pipelinesSelector, useGetPipelinesByObjectQuery} from "@ots-frontend/ots-data";
import {Card, CardProps} from "../Card/Card";
import {skipToken} from "@reduxjs/toolkit/query";
import {useApp} from "../../../providers/RegionProvider/RegionProvider"
import {PipelineDataTable} from "../../data-table/PipelineDataTable/PipelineDataTable"

export type ObjectPipelineDataTableCardProps = CardProps & {
  entity: Entity
}

export const ObjectPipelineDataTableCard = (props: ObjectPipelineDataTableCardProps) => {
  const {
    entity,
    shadow = "sm",
    padding = "lg",
    radius = "md",
    withBorder = true,
    ...rest
  } = props

  const {t} = useTranslation(["common"])
  const {regionId} = useApp()

  const selectPipelines = useMemo(() => {
    return pipelinesSelector();
  }, []);

  const arg = useMemo(() => {
    if (regionId) {
      return {
        objectId: entity.id,
        objectType: entity.entityType,
        dttm: adjustToTimeZone().getTime(),
        regionId: regionId,
      }
    } else {
      return skipToken
    }
  }, [entity.id, entity.entityType, regionId])

  const {pipelines, isPipelinesLoading} = useGetPipelinesByObjectQuery(arg, {
    selectFromResult: (result) => ({
      pipelines: selectPipelines(result, {}),
      isPipelinesLoading: result.isLoading
    })
  });

  return (
    <Card shadow={shadow} padding={padding} radius={radius} withBorder={withBorder} {...rest}>
      <Group position="apart" pb="sm">
        <Title order={4}>{t("common.entity.pipeline.plural", "Pipelines")}</Title>
      </Group>

      <Divider pb="sm"/>

      <PipelineDataTable
        withBorder
        records={pipelines}
        fetching={isPipelinesLoading}
      />
    </Card>
  )
}
